import React from 'react';
import SetTitle from '../../utils/set_title';
import Header from '../../components/Headers/Header';
import KeywordIntentionsForm from './KeywordIntentionsForm';

export default function KeywordIntentions() {
  SetTitle('Keyword Intentions');
  const description = 'Carica un file con una colonna "Keyword", specifica il nome della tabella di destinazione e riceverai via mail il link alla tabella su BigQuery quando l\'analisi sarà pronta.';

  return (
    <Header
      iconClass="ni ni-bullet-list-67 text-white"
      title="Keyword Intentions"
      docLink="/docs/ranking_tools/keyword-intentions/"
      description={description}
    >
      <KeywordIntentionsForm />
    </Header>
  );
}
